import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private _httpService: HttpService) { }

  /**
   * Step 1: Request Reset Link
   */
forgotPassword(data: any) {
  return new Promise((resolve, reject) => {
    this._httpService.post('forgotPassword', data).subscribe({
      next: (res: any) => res.success == 1 ? resolve(res) : reject(res),
      error: (err) => reject(err)
    });
  });
}

  /**
   * Step 2: Verify Token
   */
  checkResetToken(data: any) {
    return new Promise((resolve, reject) => {
      this._httpService.post('checkResetToken', data).subscribe({
        next: (res: any) => {
          if (res && res.success == 1) {
            resolve(res);
          } else {
            reject(res);
          }
        },
        error: (err) => reject(err)
      });
    });
  }

  /**
   * Step 3: Set New Password
   */
  setNewPassword(data: any) {
    return new Promise((resolve, reject) => {
      this._httpService.post('setNewPassword', data).subscribe({
        next: (res: any) => {
          if (res && res.success == 1) {
            resolve(res);
          } else {
            reject(res);
          }
        },
        error: (err) => reject(err)
      });
    });
  }

    getProduct() {

    return new Promise((resolve, reject) => {
      this._httpService.getWithAuth('getItem').subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }

// Purchase Total
    getSalePurchaseTotal(payload?: {
      financial_year_id?: string | number;
      start_date?: string;
      end_date?: string;
    }) {
    let params = new HttpParams();
    if (payload?.financial_year_id !== undefined && payload.financial_year_id !== null) {
      params = params.set('financial_year_id', String(payload.financial_year_id));
    }
    if (payload?.start_date) {
      params = params.set('start_date', payload.start_date);
    }
    if (payload?.end_date) {
      params = params.set('end_date', payload.end_date);
    }
    const endpoint = params.keys().length
      ? `getSummaryByLedger?${params.toString()}`
      : 'getSummaryByLedger';

    return new Promise((resolve, reject) => {
      this._httpService.getWithAuth(endpoint).subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }

  /**
   * Fetch Dashboard Payment Lists
   * @param payload - Contains financial_year_id, start_date, end_date
   * @returns Promise with payment list data
   */
  getPaymentLists(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpService.postWithAuth('getDashboardPaymentLists', payload).subscribe({
        next: (res: any) => {
          if (res && res.success === 1 && res.status_code === 200) {
            resolve(res);
          } else {
            reject(res || { message: 'Unable to fetch payment lists' });
          }
        },
        error: (err) => reject(err)
      });
    });
  }

  // ==========================================
  // CLIENT & ACCOUNT MANAGEMENT
  // ==========================================

  getClientList() {
    return new Promise((resolve, reject) => {
      this._httpService.getWithAuth('getCustomer').subscribe({
        next: (res: any) => resolve(res.status_code == 200 ? res.data : res),
        error: (err) => reject(err)
      });
    });
  }

  getaccountTypes() {
    return new Promise((resolve, reject) => {
      this._httpService.getWithAuth('getAccountTypes').subscribe({
        next: (res: any) => resolve(res.status_code == 200 ? res.data : res),
        error: (err) => reject(err)
      });
    });
  }

  // ==========================================
  // FINANCIAL YEAR MANAGEMENT
  // ==========================================

  getlastFinacialYear() {
    return new Promise((resolve, reject) => {
      this._httpService.get('getlastfinacialyear').subscribe({
        next: (res: any) => resolve(res.status_code == 200 ? res.data : res),
        error: (err) => reject(err)
      });
    });
  }

  getFinacialYearBalance(financial_year_id: any, account_types_id: any) {
    let params = new HttpParams();
    params = params.set('financial_year_id', financial_year_id);
    params = params.set('account_types_id', account_types_id);

    return new Promise((resolve, reject) => {
      this._httpService.getWithAuth('getlastPaymentRecord?' + params.toString()).subscribe({
        next: (res: any) => resolve(res.status_code == 200 ? res.data : res),
        error: (err) => reject(err)
      });
    });
  }

  addFinancialYear(data: any) {
    return new Promise((resolve, reject) => {
      this._httpService.post('addFinancialYear', data).subscribe({
        next: (res: any) => {
          if (res && (res.status_code == 200 || res.success == 1)) {
            resolve(res);
          } else {
            reject(res);
          }
        },
        error: (err) => reject(err)
      });
    });
  }

  addFYPreviousBalance(data: any) {
    return new Promise((resolve, reject) => {
      this._httpService.post('addfinancialBalance', data).subscribe({
        next: (res: any) => {
          if (res && (res.status_code == 200 || res.success == 1)) {
            resolve(res);
          } else {
            reject(res);
          }
        },
        error: (err) => reject(err)
      });
    });
  }

  getBalancesList(ledger_account_id: any, financial_year_id: any) {
    let params = new HttpParams();
    params = params.set('ledger_account_id', ledger_account_id);
    params = params.set('financial_year_id', financial_year_id);

    return new Promise((resolve, reject) => {
      this._httpService.getWithAuth('getPaymentRecordByClient?' + params.toString()).subscribe({
        next: (res: any) => resolve(res.status_code == 200 ? res.data : res),
        error: (err) => reject(err)
      });
    });
  }

}
